import "core-js/modules/es.number.constructor.js"; //
//
//
//
//
//
//
//

export default {
  props: {
    iconType: {
      oneOf: [0, 1, 2],
      //对应 [ 'line', 'up', 'down' ]
      type: Number
    },
    isSmall: {
      type: Boolean,
      default: false // 首页榜单模块为true

    },
    showIcon: {
      type: Boolean,
      default: true
    },
    number: {
      type: Number
    }
  },
  data: function data() {
    return {
      iconTypeArr: ['https://obj.pipi.cn/festatic/common/media/1654480202566-top_tag_line.png', 'https://obj.pipi.cn/festatic/common/media/1654480199164-top_tag_up.png', 'https://obj.pipi.cn/festatic/common/media/1654480191079-top_tag_down.png']
    };
  }
};